import React from 'react'
import {observer} from 'mobx-react'
import PropTypes from 'prop-types'
import ReviewFormInnerService from '~/components/forms/review_form/review_form_inner_service'
import ReviewFormInnerNickname from '~/components/forms/review_form/review_form_inner_nickname'
import ReviewFormInnerContent from '~/components/forms/review_form/review_form_inner_content'
import ReviewFormInnerEmail from '~/components/forms/review_form/review_form_inner_email'
import ReviewFormInnerRateStar from '~/components/forms/review_form/review_form_inner_rate_star'
import ReviewFormInnerUpdateNickname from "~/components/forms/review_form/review_form_inner_update_nickname"

@observer
export default class ReviewFormInner extends React.Component {
  static propTypes = {
    reviewFormStore: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      services: props.reviewFormStore.services || "undefined",
      user_info: props.reviewFormStore.user_info
    }
    this.onClickSubmit = this.handleClickSubmit.bind(this)
  }

  handleClickSubmit() {
    this.props.reviewFormStore.postReview(this.createPostParams())
  }

  setServiceId(serviceId) {
    this.props.reviewFormStore.setSelectedServiceId(serviceId)
  }

  setServiceImageUrl(serviceImageUrl) {
    this.props.reviewFormStore.setSelectedServiceImageUrl(serviceImageUrl)
  }

  createPostParams() {
    const reviewData = {
      review: {
        reviewer_name: this.props.reviewFormStore.nickname,
        reviewer_email: this.props.reviewFormStore.email,
        content: this.props.reviewFormStore.content,
        rating: this.props.reviewFormStore.rating,
        service_id: this.props.reviewFormStore.selectedServiceId,
        update_nickname: this.props.reviewFormStore.updatesNickname
      }
    }
    return reviewData
  }

  render() {
    return (
      <div className="reviewpopup-Inner">
        <form className="hikakaku_form">
          <div className="reviewpopup-Form">
            <div className="reviewpopup-Form_content info">
              <ReviewFormInnerService serviceId={this.props.reviewFormStore.selectedServiceId} services={this.props.reviewFormStore.services} />
              <ReviewFormInnerRateStar reviewFormStore={this.props.reviewFormStore} />
            </div>
            <div className="reviewpopup-Form_graybar"></div>
            <ReviewFormInnerContent reviewFormStore={this.props.reviewFormStore} />
            <div className="reviewpopup-Form_graybar"></div>
            <ReviewFormInnerNickname reviewFormStore={this.props.reviewFormStore} />
            <div className="reviewpopup-Form_graybar"></div>
            {
              this.props.reviewFormStore.requireEmailInput &&
              <ReviewFormInnerEmail reviewFormStore={this.props.reviewFormStore}/>
            }
            <div colSpan="2" className="reviewpopup-CheckConfirm">
              {
                this.props.reviewFormStore.asksIfUpdatesNickname &&
                  <ReviewFormInnerUpdateNickname reviewFormStore={this.props.reviewFormStore}/>
              }
              <div colSpan="2"><input className="reviewpopup-SubmitButton" type="button" value="クチコミを投稿する" onClick={this.onClickSubmit} /></div>
              <div className="reviewpopup-CheckConfirm_attention">
                投稿と同時に<a href="/review-term/" target="_blank" rel="noopener noreferrer">クチコミ利用規約</a>に同意したとみなされます
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }
}
